<div class="row">
	<span *ngIf="!resultsExist">
		<span class="scania-icon-info xs"></span>
		<span class="bold">You are not authorized to view these test results</span>
	</span>
	<div class="col-md-12" [ngClass]="{ loader: gettingTestRuns }"></div>
	<div [hidden]="!resultsExist || gettingTestRuns">
		<div class="col-md-9">
			@if (environment !== TargetEnvironment.Hero) {
				<div class="col-md-4">
					<a href="{{ reportsurl }}reports?testRunUid={{ testRun?.testRun.testRunUid }}&fromDate={{ executionDateUTCString }}&toDate={{ executionDateUTCString }}" target="_blank">
						<u>
							<h5 class="scania-link no-margin" title="Link to Test Reports Web site">
								Create report for this test run
								<span class="scania-icon-report sm" style="padding-bottom: 20px"></span>
							</h5>
						</u>
					</a>
					<a href="{{ fenixReportsUrl }}reports?testRunUid={{ testRun?.testRun.testRunUid }}&fromDate={{ executionDateUTCString }}&toDate={{ executionDateUTCString }}" target="_blank">
						<u>
							<h5 class="scania-link no-margin" title="Link to Fenix Test Reports Web site">
								Create Fenix reports
								<span class="scania-icon-report sm" style="padding-bottom: 20px"></span>
							</h5>
						</u>
					</a>
				</div>
			} @else {
				<div class="col-md-4">
					<a href="{{ fenixReportsUrl }}reports?testRunUid={{ testRun?.testRun.testRunUid }}&fromDate={{ executionDateUTCString }}&toDate={{ executionDateUTCString }}" target="_blank">
						<u>
							<h5 class="scania-link no-margin" title="Link to Fenix Test Reports Web site">
								Create report for this test run
								<span class="scania-icon-report sm" style="padding-bottom: 40px"></span>
							</h5>
						</u>
					</a>
				</div>
			}
			<div style="text-align: right">
				<span
					*ngIf="testRun?.testRunType === 410; else elseBlockListAll"
					[routerLink]="['/testspecification/', testRun?.testSpecification?.uid]"
					class="scania-link small-font"
					style="align-items: right"
				>
					[View all results for this test specification
				</span>
				<ng-template #elseBlockListAll>
					<span [routerLink]="['/testsuite/', testRun?.testSuite?.testSuiteUid]" class="scania-link small-font" style="align-items: right">[View all results for this test suite]</span>
				</ng-template>
			</div>
		</div>
		<div id="divTestRunHeading" class="col-md-12 no-padding">
			<div class="testrun-heading">
				<span *ngIf="testRun?.testRunType === 410; else elseBlockHeading">
					<h2>TEST RUN: {{ testRun?.testSpecification?.itemNo }} - {{ testRun?.testSpecification?.name }}</h2>
				</span>
				<ng-template #elseBlockHeading>
					<h2>TEST RUN: {{ testRun?.testSuite?.itemNo }} - {{ testRun?.testSuite?.name }}</h2>
				</ng-template>
			</div>
			<div class="testrun-heading-details">
				<span *ngIf="testRun?.testRunType === 410; else elseBlockDetailHeading">
					&nbsp;(version {{ testRun?.testSpecification?.version }}) -
					{{
						testRun?.testRun?.executionTime
							| date
								: 'yyyy-MM-dd
          HH:mm:ss'
					}}
					- {{ testRun?.testRun?.environment | uppercase }} - {{ testRun?.testRun?.regBy | uppercase }}
				</span>
				<ng-template #elseBlockDetailHeading>
					&nbsp;(version {{ testRun?.testSuite?.version }}) -
					{{
						testRun?.testRun?.executionTime
							| date
								: 'yyyy-MM-dd
          HH:mm:ss'
					}}
					- {{ testRun?.testRun?.environment | uppercase }} - {{ testRun?.testRun?.regBy | uppercase }}
				</ng-template>
			</div>
		</div>

		<div id="divTestRun" class="col-md-9">
			<mat-accordion multi>
				<mat-expansion-panel [expanded]="true" class="bottom-margin">
					<mat-expansion-panel-header>
						<mat-panel-title>Test run statistics</mat-panel-title>
					</mat-expansion-panel-header>
					<div class="col-md-12">
						<div id="divTestRunStatistics" class="col-md-9 statistics-chart-margin">
							<ngx-charts-pie-chart
								[view]="view"
								[scheme]="colorScheme"
								[results]="testResultStatistics"
								[gradient]="true"
								[legend]="true"
								[legendTitle]="''"
								[legendPosition]="'below'"
								[labels]="true"
								[trimLabels]="false"
								[doughnut]="false"
								(select)="onSelect($event)"
								(activate)="onActivate($event)"
								(deactivate)="onDeactivate($event)"
							></ngx-charts-pie-chart>
						</div>
						<div class="col-md-3">
							<h5>Input types</h5>
							<table class="bottom-margin-small">
								<tr *ngFor="let input of testRunStatistics?.inputStatistics">
									<td class="no-padding" style="width: 60%">{{ input.type }}</td>
									<td class="no-padding">{{ input.count }}</td>
								</tr>
							</table>
							<hr />
							<h5>Trouble reports (TR)</h5>
							<table class="bottom-margin-small">
								<tr>
									<td class="no-padding" style="width: 60%">Number of unique TR</td>
									<td class="no-padding">{{ uniqueTroubleReportNamesInStatistics?.length }}</td>
								</tr>
								<tr>
									<td class="no-padding">Failed without TR</td>
									<td class="no-padding">{{ failedResultsWithoutTroubleReport.length }}</td>
								</tr>
							</table>
						</div>
					</div>
				</mat-expansion-panel>
				<div class="bottom-margin-small">
					<mat-expansion-panel [expanded]="false" class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								Test results for test run
								<span class="badge badge-default">{{ this.testRun?.testRun?.testResults?.length }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divTestRunTableHeader" class="col-md-12 no-padding">
							<div class="no-padding col-md-12">
								<!-- <span class="col-md-3 results-filter-empty"></span> -->
								<span *ngIf="includesNotExecuted" class="results-filter-checkboxes">
									<fieldset class="results-filter-fieldset">
										<legend class="results-filter-legend">Show results where Not Executed reason is set to:</legend>
										<span *ngFor="let item of notExecutedTypes; first as isFirst">
											<label
												[class.failedreasonNANPBySystem]="item.name === 'FailedBySystem'"
												[class.failedreasonNANPByUser]="item.name === 'FailedByUser'"
												[class.first-failed-reason]="isFirst"
											>
												<input class="checkbox" type="checkbox" checked="true" (change)="onChangeNotExecutedType(item.name, $event.target.checked)" />
												<i *ngIf="item.name === 'FailedByUser'" class="scania-icon-search-mobile xs"></i>
												{{ item.value }}
											</label>
										</span>
									</fieldset>
								</span>
								<span id="divTestRunFilter" class="col-md-2 align-right no-padding results-filter-text">
									<input type="text" id="txtSearchTestRun" class="form-control" placeholder="Filter..." (keyup)="applyFilter($event)" />
								</span>
							</div>
						</div>
						<div class="mat-elevation-z0">
							<table mat-table [dataSource]="dataSource" matSort>
								<ng-container matColumnDef="testResultUid">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Test result UID</th>
									<td mat-cell *matCellDef="let element">{{ element?.testResultUid }}</td>
								</ng-container>
								<ng-container matColumnDef="testCaseItemNo">
									<th mat-header-cell *matHeaderCellDef mat-sort-header width="10%">ItemNo</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="{
											failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
											failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
										}"
									>
										<i *ngIf="element.failedReason !== 0 && element.failedBy !== 'System'" class="scania-icon-search-mobile xs" title="Not executed by user"></i>
										{{ element.testCaseItemNo }}
									</td>
								</ng-container>
								<ng-container matColumnDef="testCaseName">
									<th mat-header-cell *matHeaderCellDef mat-sort-header width="20%">Test case name</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="{
											failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
											failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
										}"
									>
										<i *ngIf="element.failedReason !== 0 && element.failedBy !== 'System'" class="scania-icon-search-mobile xs" title="Not executed by user"></i>
										{{ element?.testCaseName }}
										<!-- Use below link when start showing history of test case -->
										<!-- <a routerLink="/testcase/{{element.testCaseUid}}" routerLinkActive="active">{{element.testCaseName}}</a> -->
									</td>
								</ng-container>
								<ng-container matColumnDef="result">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Result</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="{
											failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
											failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
										}"
									>
										{{ element.result }}
									</td>
								</ng-container>
								<ng-container matColumnDef="troubleReports">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Trouble reports</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="{
											failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
											failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
										}"
									>
										<i *ngIf="element.troubleReports?.length > 0" class="scania-icon-trouble-report xs" title="Trouble reports exist"></i>
									</td>
								</ng-container>
								<ng-container matColumnDef="resultComment">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Result comment</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="{
											failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
											failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
										}"
									>
										<span *ngIf="element.resultComment && element.resultText; else elseBlockResultComment">
											<button
												*ngIf="element.resultComment && element.resultText"
												mat-button
												(click)="$event.stopPropagation(); openDialog(element.resultComment, element.resultText)"
												class="icon-button"
												title="View result text"
											>
												<div class="icon-button-text">{{ element.resultComment }}</div>
												<div class="icon-button-icon"><mat-icon>more_horiz</mat-icon></div>
											</button>
										</span>
										<ng-template #elseBlockResultComment>
											<span *ngIf="element.resultComment">
												{{ element.resultComment }}
											</span>
										</ng-template>
										<div *ngIf="(element?.positiveComment !== '' && element?.positiveComment !== null) || (element?.negativeComment !== '' && element?.negativeComment !== null)">
											<table class="table-condensed no-margin">
												<tbody>
													<tr *ngIf="element?.positiveComment !== '' && element?.positiveComment !== null">
														<td class="no-padding" title="Positive comment">
															<span class="glyphicon glyphicon-ok-sign text-success"></span>
															{{ element?.positiveComment }}
														</td>
													</tr>
													<tr *ngIf="element?.negativeComment !== '' && element?.negativeComment !== null">
														<td class="no-padding" title="Negative comment">
															<span class="glyphicon glyphicon-remove-sign text-danger"></span>
															{{ element?.negativeComment }}
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</td>
								</ng-container>
								<ng-container matColumnDef="failedReasonText">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Not executed reason</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="{
											failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
											failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
										}"
									>
										{{ element.failedReason === 0 ? '' : element.failedReasonText }}
									</td>
								</ng-container>
								<ng-container matColumnDef="failedBy">
									<th mat-header-cell *matHeaderCellDef width="10%">Not executed decided by</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="{
											failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
											failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
										}"
									>
										{{ element.failedBy }}
									</td>
								</ng-container>
								<ng-container matColumnDef="failedReasonComment">
									<th mat-header-cell *matHeaderCellDef>Not executed comment</th>
									<td mat-cell *matCellDef="let element">
										<span *ngIf="element.failedReasonComment && element.errorText; else elseBlockFailedReasonComment">
											<button
												*ngIf="element.failedReasonComment && element.errorText"
												mat-button
												(click)="$event.stopPropagation(); openDialog(element.failedReasonComment, element.errorText)"
												class="icon-button"
												title="View Not executed text"
											>
												<span class="icon-button-text">{{ element?.failedReasonComment }}</span>
												<span class="icon-button-icon"><mat-icon>more_horiz</mat-icon></span>
											</button>
										</span>
										<ng-template #elseBlockFailedReasonComment>
											<span *ngIf="element.failedReasonComment">
												{{ element?.failedReasonComment }}
											</span>
										</ng-template>
									</td>
								</ng-container>
								@if (environment !== TargetEnvironment.Hero) {
									<ng-container matColumnDef="testCaseAlternativeFailedReasons">
										<th mat-header-cell *matHeaderCellDef>Test case alternative: failed reason</th>
										<td mat-cell *matCellDef="let element">
											<table *ngIf="tcAlternativeFailedReasonsExist">
												<tr *ngFor="let failedReason of element.testCaseAlternativeFailedReasons">
													<td class="no-padding">
														<span
															title="Derived from test case alternative: {{ failedReason.testCaseAlternativeName }} &#xA;with UID: {{
																failedReason.testCaseAlternativeUid
															}}"
														>
															{{ failedReason?.testCaseAlternativeName }}: {{ failedReason?.failedComment }}
															<span class="scania-icon-help xs" style="padding-bottom: 20px"></span>
														</span>
													</td>
												</tr>
											</table>
										</td>
									</ng-container>
								}
								<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: displayedColumns"
									[ngClass]="{ failed: row.result === 'failed', passed: row.result === 'passed', hovered: row.hovered }"
									(focus)="row.hovered = true"
									(mouseover)="row.hovered = true"
									(blur)="row.hovered = false"
									(mouseout)="row.hovered = false"
									(click)="navigateTo(row)"
									[hidden]="row?.hide === true"
								></tr>
							</table>
							<mat-paginator [pageSizeOptions]="getPageSizeOptions()" showFirstLastButtons></mat-paginator>
						</div>
					</mat-expansion-panel>
				</div>

				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								ECU identification readout (XCOM)
								<span class="badge badge-default">{{ this?.totalEcuReadouts }}</span>
								<span *ngIf="this.originEcuReadout" class="small-font-italic">{{ this?.originEcuReadout }}</span>
								<span *ngIf="this.fileTimeEcuReadout" class="small-font-italic">File creation time: {{ this?.fileTimeEcuReadout | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						@if (environment !== TargetEnvironment.Hero) {
							@if (xcomFiles$ | async; as files) {
								@if (files.length) {
									<app-attachments [files]="files" [hideImportTime]="ecuReadoutsFromDatabase"></app-attachments>
								}
							}
						}
						<div id="divEcuReadouts" *ngIf="testRun?.testRun?.testRunUid">
							<app-ecu-readout (countEcuReadouts)="showEcuReadoutCounts($event)" (readoutsFromDatabase)="onReadoutsFromDatabase($event)"></app-ecu-readout>
						</div>
					</mat-expansion-panel>
				</div>

				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								E2 parameters
								<span class="badge badge-default">{{ this?.totalEcuParams }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divEcuParams" *ngIf="testRun?.testRun?.testRunUid">
							@if (environment !== TargetEnvironment.Hero) {
								@if (e2Files$ | async; as files) {
									@if (files.length) {
										<app-attachments [files]="files" [hideImportTime]="ecuParamsFromDatabase"></app-attachments>
									}
								}
							}
							<app-ecu-param (countEcuParams)="showEcuParamCounts($event)" (paramsFromDatabase)="onParamsFromDatabase($event)"></app-ecu-param>
						</div>
					</mat-expansion-panel>
				</div>

				@if (environment !== TargetEnvironment.Hero) {
					@if (atsFiles$ | async; as files) {
						@if (files.length) {
							<div class="bottom-margin-small">
								<mat-expansion-panel class="bottom-margin">
									<mat-expansion-panel-header>
										<mat-panel-title>ATS</mat-panel-title>
									</mat-expansion-panel-header>
									<app-attachments [files]="files"></app-attachments>
								</mat-expansion-panel>
							</div>
						}
					}
				}

				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								Properties for test run
								<span class="badge badge-default">{{ this?.totalRunProperties }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divProperties" *ngIf="testRun?.testRun.testRunUid">
							<app-test-run-properties [runUid]="testRun?.testRun.testRunUid" (countRunProperties)="showRunPropertiesCount($event)"></app-test-run-properties>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								SOPS
								<span class="badge badge-default">{{ this?.totalSOPS }}</span>
								<span *ngIf="this.originSOPS" class="small-font-italic">{{ this?.originSOPS }}</span>
								<span *ngIf="this.fileTimeSOPS" class="small-font-italic">File creation time: {{ this?.fileTimeSOPS | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
								<span *ngIf="this.versionSOPS" class="small-font-italic">File version: {{ this?.versionSOPS }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divSOPS" *ngIf="testRun?.testRun?.testRunUid">
							<app-sops
								[runUid]="testRun?.testRun?.testRunUid"
								(countTotalSOPS)="showSOPSCounts($event)"
								(sopsOrigin)="showSOPSOrigin($event)"
								(sopsFileTime)="showSOPSFileTime($event)"
								(sopsVersion)="showSOPSVersion($event)"
								(sopsFPCs)="showSOPSFPCs($event)"
							></app-sops>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>Offboard components</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divDataComponents" *ngIf="testRun?.testRun?.testRunUid">
							@if (environment !== TargetEnvironment.Hero) {
								@if (offboardFiles$ | async; as files) {
									<app-attachments [files]="files"></app-attachments>
								}
							}
							<app-offboard-component [runUid]="testRun?.testRun?.testRunUid" (countOffboardComponents)="showOffboardComponentsCount($event)"></app-offboard-component>
						</div>
					</mat-expansion-panel>
				</div>
			</mat-accordion>
		</div>

		<div id="TestRunAdditionalData" class="col-md-3">
			<div id="Environment" class="col-md-12 bottom-margin-small">
				<mat-expansion-panel [expanded]="true">
					<mat-expansion-panel-header>
						<mat-panel-title>Environment for test run</mat-panel-title>
					</mat-expansion-panel-header>
					@if (testRun?.testRun?.environment === 'No_Vehicle' || environment === TargetEnvironment.Hero) {
						<span>
							<h4>{{ testRun?.testRun?.environment }}</h4>
						</span>
					} @else if (testRun?.testRun?.environment !== 'No_Vehicle') {
						<span>
							<a href="https://testvehicle.scania.com/#/view;testCarrier={{ testRun?.testRun.environment }}" target="_blank">
								<u>
									<h4
										class="scania-link"
										title="Link to TESTiT Test Vehicles site for this environment. Requires access which can be ordered from OrderIT. Not all environments are represented in TESTiT. "
									>
										{{ testRun?.testRun?.environment }}
									</h4>
								</u>
							</a>
						</span>
					}
					<div id="divEnvironment" *ngIf="FPCsSOPS?.length > 0">
						<app-environment [VINNo]="testRun?.testRun?.vinNo" [FPCs]="FPCsSOPS"></app-environment>
					</div>
				</mat-expansion-panel>
			</div>
			<div id="TestRunDetails" class="col-md-12">
				<mat-expansion-panel [expanded]="true">
					<mat-expansion-panel-header>
						<mat-panel-title>Test run details</mat-panel-title>
					</mat-expansion-panel-header>
					<table id="tableTestRunDetails" class="table-condensed">
						<tbody>
							<tr>
								<td width="40%">Status of test run</td>
								<td width="5px;"></td>
								<td *ngIf="testRunStatusDescription === 'Draft'">
									<span style="color: red">{{ testRunStatusDescription }}</span>
								</td>
								<td *ngIf="testRunStatusDescription === 'Final'">{{ testRunStatusDescription }}</td>
							</tr>
							<tr title="If the test run is going to be used (Valid) or not (Not valid)">
								<td>
									Classification
									<span class="scania-icon-help xs" style="padding-bottom: 20px"></span>
								</td>
								<td width="5px;"></td>
								<td *ngIf="classificationDescription === 'Valid'">{{ classificationDescription }}</td>
								<td *ngIf="classificationDescription === 'NotValid'">
									<span style="color: red">{{ classificationDescription }}</span>
								</td>
							</tr>
							<tr *ngIf="classificationReasonDescription !== 'OK'" title="What causes the test run to not be valid">
								<td>
									Classification reason
									<span class="scania-icon-help xs" style="padding-bottom: 20px"></span>
								</td>
								<td width="5px;"></td>
								<td>{{ classificationReasonDescription }}</td>
							</tr>
							<tr *ngIf="testRun?.testRun?.classificationComment?.length > 0">
								<td>Classification comment</td>
								<td width="5px;"></td>
								<td>{{ testRun?.testRun?.classificationComment }}</td>
							</tr>
							<tr>
								<td>Test run UID</td>
								<td width="5px;"></td>
								<td>{{ testRun?.testRun?.testRunUid }}</td>
							</tr>
							<tr>
								<td>Execution time</td>
								<td width="5px;"></td>
								<td>{{ testRun?.testRun?.executionTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
							</tr>
							<tr>
								<td>Executed by</td>
								<td width="5px;"></td>
								<td style="word-wrap: break-word">{{ testRun?.testRun?.regBy }}</td>
							</tr>
							<tr>
								<td>SOP</td>
								<td width="5px;"></td>
								<td>{{ testRun?.testRun?.sop }}</td>
							</tr>
							<tr>
								<td>Test period</td>
								<td width="5px;"></td>
								<td>{{ testRun?.testRun?.testPeriod }}</td>
							</tr>
						</tbody>
					</table>
					<table class="table-condensed" width="100%">
						<tbody width="100%">
							<span *ngIf="testRun?.testRunType === 410; else elseBlockType">
								<tr
									class="scania-link"
									[routerLink]="['/testspecificationdetails']"
									[queryParams]="{ uid: testRun?.testSpecification?.uid, version: testRun?.testSpecification?.version }"
									title="Show test specification details page"
								>
									<td class="scania-link" width="40%">Test specification ItemNo</td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ testRun?.testSpecification?.itemNo }}</u>
									</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testspecificationdetails']"
									[queryParams]="{ uid: testRun?.testSpecification?.uid, version: testRun?.testSpecification?.version }"
									title="Show test specification details page"
								>
									<td class="scania-link" width="40%">Test specification</td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ testRun?.testSpecification?.name }}</u>
									</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testspecificationdetails']"
									[queryParams]="{ uid: testRun?.testSpecification?.uid, version: testRun?.testSpecification?.version }"
									title="Show test specification details page"
								>
									<td class="scania-link">Test specification UID</td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ testRun?.testSpecification?.uid }}</u>
									</td>
								</tr>
								<tr>
									<td>Test specification version</td>
									<td width="5px;"></td>
									<td>{{ testRun?.testSpecification?.version }}</td>
								</tr>
							</span>
							<ng-template #elseBlockType>
								<tr
									class="top-border scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: testRun?.testSuite?.testSuiteUid, version: testRun?.testSuite?.version }"
									title="Show test suite details page"
								>
									<td class="scania-link" width="40%"><u>Test suite ItemNo</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ testRun?.testSuite?.itemNo }}</u>
									</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: testRun?.testSuite?.testSuiteUid, version: testRun?.testSuite?.version }"
									title="Show test suite details page"
								>
									<td class="scania-link" width="40%"><u>Test suite</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ testRun?.testSuite?.name }}</u>
									</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: testRun?.testSuite?.testSuiteUid, version: testRun?.testSuite?.version }"
									title="Show test suite details page"
								>
									<td class="scania-link"><u>Test suite UID</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ testRun?.testSuite?.testSuiteUid }}</u>
									</td>
								</tr>
								<tr>
									<td>Test suite version</td>
									<td width="5px;"></td>
									<td>{{ testRun?.testSuite?.version }}</td>
								</tr>
							</ng-template>
						</tbody>
					</table>
				</mat-expansion-panel>
			</div>
		</div>
	</div>
</div>
